import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { OutlinedInput } from '@material-ui/core';

import Ports from '../../models/Ports';
import GhaHeaderOptionsModel from '../../models/GhaHeaderOptions';

import appStyles from '../../App/app.module.css';
import forwarderStyles from './forwarderHeader.module.css';
import commonStyles from '../common/common.module.css';

import { Label } from '@material-ui/icons';

const iconFontSize = 30;
const styles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    disabledIcon: {
      fontSize: iconFontSize,
      color: 'rgb(204, 204, 204)'
    },
    awbLabel: {
      fontSize: '13px',
      paddingRight: '10px'
    },
    inputBorder: {
      width: '100%',
      '& >:before': {
        borderBottom: 'none'
      }
    }
  });

interface HeaderProps {
  classes: any;
  ports: Ports;
  ghas: GhaHeaderOptionsModel[];
  portValue: string;
  ghaValue: number;
  awbValue: string;
  handleChange: Function;
  handleKeyDown: any;
  addClicked: any;
  isDisabled: Function;
};

const ForwarderHeader = (props: HeaderProps) => {

  const { classes } = props;
  const portsArr: Array<string> = Object.keys(props.ports);
  const portOptions: Array<JSX.Element> = portsArr.map((port: string , index: number) => (
    <option key={ index }>{ port }</option>
  ));
  
  const ghaOptions: Array<JSX.Element> = props.ghas.map((gha: GhaHeaderOptionsModel, index: number) => (
    <option key={ index } value={ gha.id }>{ gha.name }</option>
  ));

  return (
    <div className={ appStyles.row }>
      <div className={ forwarderStyles.formControlWrapper }>
        <FormControl className={ forwarderStyles.formControl } >
          <div className={ commonStyles.inputLabel }>Port</div>
          <Select native
            onChange={ props.handleChange('port') }
            value={ props.portValue }
            inputProps={{
              name: 'port',
              id: 'port',
            }}
            className={ forwarderStyles.selectIp }
            input={ <OutlinedInput labelWidth={ 0 }  /> }
          >
          { portOptions }
          </Select>
        </FormControl>
      </div>
      <div className={ forwarderStyles.formControlWrapper }>
        <FormControl className={ forwarderStyles.formControl }>
          <div className={ commonStyles.inputLabel }>GHA</div>
          <Select native
            onChange={ props.handleChange('gha') }
            value={ props.ghaValue }
            inputProps={{
              name: 'gha',
              id: 'gha',
            }}   
            className={ forwarderStyles.selectIp }
            input={ <OutlinedInput labelWidth={ 0 }  /> }
          >
          { ghaOptions }
          </Select>
        </FormControl>
      </div>
      <div className={ `${ commonStyles.inputLabelWrapper } ${ forwarderStyles.textFieldWrapper } ${ commonStyles.mt0 }` }>
        <label className={ commonStyles.inputLabel }>Enter Airwaybill</label>
        <div className={ forwarderStyles.positionrelative }>
          <TextField
            id="awb"
            onChange={ props.handleChange('awb') }
            onKeyDown={ props.handleKeyDown }
            value={ props.awbValue }
            InputProps={{
              className: [commonStyles.searchIpField].join(' '),
              classes: { input: forwarderStyles.awbIp },
            }}
            InputLabelProps={{
              className: classes.awbLabel
            }}
            placeholder="Enter Airwaybill"
            className={ classes.inputBorder}
            variant="outlined"
          />
          <div className={ `${forwarderStyles.formControlWrapper} ${forwarderStyles.addButtonWrapper}` }>
            { !props.isDisabled()
              ? <AddCircleIcon color="primary" className={ [ classes.materialIcon, classes.marginTop8px ].join(' ') } onClick={ props.addClicked } />
              : <AddCircleIcon className={ [ classes.disabledIcon, classes.marginTop8px ].join(' ') } />
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default withStyles(styles)(ForwarderHeader);
